window.app = APP_CONFIG //eslint-disable-line
window.app.cacheKeys = window.appCacheKeys
delete window.APP_CONFIG
delete window.appCacheKeys

if (!window.app.config) throw new Error('!window.app.config: Have APP_KEY and CONFIG_KEY environment variables set?')
if (!window.app.config.backendConfig) throw new Error('!window.app.config.backendConfig: Has BACKEND_CONFIG_KEY environment variables set?')
